import { GpsReading } from '../../domain/telemetry/raw/GpsReading'

export const parseGpx = (text: string): GpsReading[] => {
  const readings: GpsReading[] = []
  const trackPoint = /<trkpt\b([^>]*)>([\s\S]*?)<\/trkpt>/g

  let match: RegExpExecArray | null
  while ((match = trackPoint.exec(text)) !== null) {
    const [, attributes, body] = match
    const latitude = numericAttribute(attributes, 'lat')
    const longitude = numericAttribute(attributes, 'lon')
    const time = childText(body, 'time')
    if (latitude == null || longitude == null || time == null) continue

    const timestamp = new Date(time)
    if (Number.isNaN(timestamp.getTime())) continue

    const altitude = numericChild(body, 'ele')
    const speedMs = numericChild(body, 'speed')

    readings.push({
      latitude,
      longitude,
      timestamp,
      ...(altitude != null && { altitude }),
      ...(speedMs != null && { speedMs }),
    })
  }

  return readings
}

const numericAttribute = (attributes: string, name: string): number | null => {
  const found = new RegExp(`\\b${name}\\s*=\\s*"([^"]*)"`).exec(attributes)
  return found ? finiteOrNull(found[1]) : null
}

const childText = (body: string, name: string): string | null => {
  const optionalNamespacePrefix = '(?:[\\w.-]+:)?'
  const found = new RegExp(
    `<${optionalNamespacePrefix}${name}\\b[^>]*>([^<]*)</${optionalNamespacePrefix}${name}>`
  ).exec(body)
  return found ? found[1].trim() : null
}

const numericChild = (body: string, name: string): number | null => {
  const text = childText(body, name)
  return text == null ? null : finiteOrNull(text)
}

const finiteOrNull = (text: string): number | null => {
  const value = Number(text)
  return Number.isFinite(value) ? value : null
}
